import axios, { AxiosRequestConfig } from "axios";


const freezeFactoring = async (factoringId: string, reason: string): Promise<any> => {
    const url = `/factoring/${factoringId}/freeze/`;
    const options: AxiosRequestConfig = {
        url,
        method: "POST",
        data: { reason }
    };
    const response = await axios(options);
    return response.data;
};

const unfreezeFactoring = async (factoringId: string, reason: string): Promise<any> => {
    const url = `/factoring/${factoringId}/unfreeze/`;
    const options: AxiosRequestConfig = {
        url,
        method: "POST",
        data: { reason }
    };
    const response = await axios(options);
    return response.data;
};

const getFreezeEvents = async (factoringId: string): Promise<any> => {
    const url = `/factoring/${factoringId}/freeze_events/`;
    const options: AxiosRequestConfig = {
        url,
        method: "GET"
    };
    const response = await axios(options);
    return response.data;
};

const getFreezeEventsByUrl = async (url: string): Promise<any> => {
    const options: AxiosRequestConfig = {
        url,
        method: "GET"
    };
    const response = await axios(options);
    return response.data;
};

const getFreezeExemptContractTypes = async (factoringId: string): Promise<any> => {
    const options: AxiosRequestConfig = {
        url: `/factoring/${factoringId}/freeze_exempt_contract_types/`,
        method: "GET"
    };
    const response = await axios(options);
    return response.data;
};

const saveFreezeExemptContractTypes = async (
    factoringId: string,
    contractTypes: string[]
): Promise<any> => {
    const options: AxiosRequestConfig = {
        url: `/factoring/${factoringId}/freeze_exempt_contract_types/`,
        method: "PUT",
        data: { contract_types: contractTypes }
    };
    const response = await axios(options);
    return response.data;
};

export default {
    freezeFactoring,
    unfreezeFactoring,
    getFreezeEvents,
    getFreezeEventsByUrl,
    getFreezeExemptContractTypes,
    saveFreezeExemptContractTypes,
};
